/* eslint-disable max-lines-per-function */
import React, { useRef, useState, useEffect } from 'react';
import Vincular from '../components/Vincular.jsx';
import TvService from '../../../../services/tvs/TvService';
import { Growl } from 'primereact/growl';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens'; 

export function VincularTVs({
    rowSelecionada,
    modalVincularTVAberto,
    setModalVincularTVAberto    
}) {
    const limpaGrupos = () => {        
    };

    const [tvVinculadas,settvVinculadas] = useState([]);
    const [tvDisponiveis,settvDisponiveis] = useState([]);    
    const mensagemToast = useRef(null);
    const um = 1;

    useEffect(() => {
        (async () => {
            const responseDataTVs = await TvService.buscarTodaTVs();
            const tvsDisponiveis = responseDataTVs.data.filter(
                a => a.idGrupo === null && a.idGrupo !== rowSelecionada?.id && a.status === um );
            const tvVinculadasaoGrupo = responseDataTVs.data.filter(a => a.idGrupo === rowSelecionada?.id);
           
            settvVinculadas(tvVinculadasaoGrupo);
            settvDisponiveis(tvsDisponiveis);
        })();
    }, [rowSelecionada]);    

    const onSubmitVincularGrupos = async (fonte,alvo) => {
        try{
            await TvService.vincularTvGrupo( rowSelecionada?.id, alvo.map(a => a.id));
            await TvService.desvincularTvGrupo(rowSelecionada?.id, fonte.map(a => a.id));
            mostrarMensagemSucesso(mensagemToast,'Alterado com sucesso!');
            
            setModalVincularTVAberto(false);
        } catch (e) {
            mostrarMensagemErro(mensagemToast,'Não foi possível vinvular os aparelhos televisores! Tente novamente mais tarde.');
        }
    };
   
    return (
        <>
            <Growl ref={mensagemToast} />
            <Vincular 
                onSubmitBotaoAcao={onSubmitVincularGrupos}
                setFonte={settvDisponiveis} 
                setAlvo={settvVinculadas} 
                fonteDados={tvDisponiveis} 
                titleModal={'Vincular aparelhos televisores'} 
                fonteTitulo={'Aparelhos não vinculadas'} 
                alvoTitulo={'Aparelhos vinculadas'} 
                alvoDados={tvVinculadas} 
                openModal={modalVincularTVAberto} 
                setOpenModal={setModalVincularTVAberto}
                limpaGrupos={limpaGrupos}/>
        </>
    );
}
